if (!customElements.get('bundle-item')) {
  customElements.define(
    'bundle-item',
    class BundleItem extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.idInput = this.form.querySelector('input[name=id]');
        this.swatches = this.querySelectorAll('[data-bundle-item-swatch]')
        this.links = this.querySelectorAll('[data-bundle-item-link-el]')
        this.vendor = this.querySelector('[data-bundle-item-vendor-el]')
        this.titleEl = this.querySelector('[data-bundle-item-title-el]')
        this.images = this.querySelectorAll('[data-bundle-item-image-id]')
        this.originalPriceEl = this.querySelector('[data-bundle-original-price-el]')
        this.discountPriceEl = this.querySelector('[data-bundle-discount-price-el]')
        this.discountPriceRaw = this.querySelector('[data-bundle-discount-price-raw]')
        this.bundleDiscount = this.querySelector('[data-collection-bundle-discount]')
        this.activeSwatch = null
        this.activeImages = null

        if (typeof this.swatches === 'undefined' || typeof this.form === 'undefined') { return }

        this.initBundleItem()
      }

      async initBundleItem () {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', (event) => {
            event.preventDefault();

            const bundleId = swatch.dataset.bundleItemId
            const bundleAvailability = swatch.dataset.bundleItemAvailability
            this.idInput.value = bundleId

            // Update ATC variant ID
            this.swatches.forEach((swatch) => {
              swatch.classList.toggle('active-swatch', swatch.dataset.bundleItemId === bundleId)
              this.activeSwatch = swatch.dataset.bundleItemId === bundleId
                ? swatch
                : this.activeSwatch
            })

            this.activeImages = [...this.images].filter((image) => image.getAttribute('data-bundle-item-image-id') === bundleId)

            this.activeImages.forEach((image) => {
              if (image.classList.contains('hide')) {
                image.classList.remove('hide')
              }
            })

            const noActiveImageArr = [...this.images].filter((image) => !this.activeImages.includes(image)).forEach((image) => image.classList.add('hide'))

            this.titleEl.textContent = this.activeSwatch.getAttribute('data-bundle-item-title')
            this.vendor.textContent = this.activeSwatch.getAttribute('data-bundle-item-vendor')

            this.links.forEach((link) => {
              link.setAttribute('href', this.activeSwatch.getAttribute('data-bundle-item-url'))
            })

            this.handlePriceFormatting()

            // Disable if variant is unavaialable
            if (bundleAvailability === 'false') {
              const atc = this.form.querySelector('button[type="submit"]')
              atc.disabled = true
            }
          })
        })
      }

      handlePriceFormatting () {
        if (typeof this.bundleDiscount !== 'undefined' && typeof this.originalPriceEl !== 'undefined') {
          let bundle_discount = parseFloat(this.bundleDiscount.getAttribute('data-collection-bundle-discount'), 10)
          bundle_discount = (100 - bundle_discount) / 100

          const has_comma = this.activeSwatch.getAttribute('data-bundle-item-price-raw').includes(',')
          
          let price = this.activeSwatch.getAttribute('data-bundle-item-price')
          let price_raw = this.activeSwatch.getAttribute('data-bundle-item-price-raw')
          const price_raw_copy = price_raw
          let price_money = this.activeSwatch.getAttribute('data-bundle-item-price-money')

          
          price_raw = has_comma
            ? price_raw.replace(',', '')
            : price_raw

          let discount_price = has_comma 
            ? (price_raw * bundle_discount / 100).toFixed(2)
            : (price_raw * bundle_discount).toFixed(2)

          price_money = price_money.includes(' CAD')
            ? price_money.replace(' CAD', '')
            : price_money

          const formatted_discount_price = price.replace(price_raw_copy, discount_price)
          this.discountPriceEl.textContent = formatted_discount_price
          this.originalPriceEl.textContent = price_money
        }
      }
    }
  );
}

